<template>
  <div
    class="viewEventoRoot"
    :class="{
      videoFitOriginal: options.videoFit == 'original',
      videoFitContain: options.videoFit == 'contain',
      videoFitFill: options.videoFit == 'fill',
    }"
    @mousemove="showPlayerOptionsButton"
    @touchstart.passive="showPlayerOptionsButton"
  >
    <div
      class="row rowOpenvidu viewEventoPlayerSurface"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'openvidu'
            ? 'block'
            : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <div id="subscriber"></div>
      </div>
    </div>
    <div
      class="row rowAnt viewEventoPlayerSurface"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ant' ? 'block' : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <video
          id="remoteVideo"
          ref="antVideo"
          autoplay
          controls
          playsinline
        ></video>
      </div>
    </div>
    <div
      class="row rowFlash viewEventoPlayerSurface"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'sh' ? 'block' : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <div id="playFlash">
          <video
            id="flashPlayVideo"
            ref="flashVideo"
            controls="controls"
          ></video>
        </div>
      </div>
    </div>
    <div
      v-if="retornaSite() !== '7live'"
      class="row rowMS viewEventoPlayerSurface"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ms' ? 'block' : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <video
          id="msPlayVideo"
          ref="msVideo"
          autoplay
          controls
          playsinline
          style="display: none"
          :muted="audioMudo"
        ></video>
      </div>
    </div>
    <div
      v-if="retornaSite() == '7live'"
      id="frameVideo"
      class="viewEventoPlayerSurface"
      style="position: relative"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ms' ? 'block' : 'none',
      }"
    >
      <video
        id="msPlayVideo"
        ref="msVideo"
        autoplay
        controls
        playsinline
        style="display: none; height: 100%; max-height: 100%"
        :muted="audioMudo"
      ></video>
    </div>
    <section
      v-if="options.replay && !previewMode"
      ref="replayWindow"
      class="viewEventoReplay"
      :style="replayWindowStyle"
      :aria-label="'Replay com ' + replayDelaySeconds + ' segundos de atraso'"
    >
      <div
        class="viewEventoReplayResize"
        title="Redimensionar replay"
        @mousedown="startReplayResize"
        @touchstart="startReplayResize"
      >
        <i class="fa fa-arrows-h" aria-hidden="true"></i>
      </div>
      <header
        class="viewEventoReplayHeader"
        title="Arraste para mover o replay"
        @mousedown="startReplayDrag"
        @touchstart="startReplayDrag"
      >
        <div class="viewEventoReplayTitle">
          <i class="fa fa-history" aria-hidden="true"></i>
          <select
            v-model.number="replayDelaySeconds"
            title="Atraso do replay"
            aria-label="Atraso do replay"
            @change="changeReplayDelay"
          >
            <option :value="1">1 s</option>
            <option :value="2">2 s</option>
            <option :value="3">3 s</option>
            <option :value="4">4 s</option>
            <option :value="5">5 s</option>
          </select>
        </div>
        <div>
          <button
            type="button"
            title="Tela cheia"
            aria-label="Abrir replay em tela cheia"
            @click="fullScreenReplay"
          >
            <i class="fa fa-expand" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            title="Fechar replay"
            aria-label="Fechar replay"
            @click="stopReplay"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </header>
      <div class="viewEventoReplayBody">
        <canvas ref="replayCanvas"></canvas>
        <div v-if="!replayReady" class="viewEventoReplayStatus">
          <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
          {{ replayStatus }}
        </div>
      </div>
    </section>
    <floating-content-panel
      v-if="
        !previewMode &&
        propSofaScore &&
        item.evento &&
        (item.evento.sofaScoreId || item.evento.sofaScore) &&
        options.sofascore &&
        options.sofascoreFloat
      "
      title="SofaScore"
      icon-class="fa fa-line-chart"
      storage-key="viewEventoFloatingSofascore"
      :initial-width="540"
      :initial-height="124"
      :fixed-height="124"
      :z-index="1061"
      @close="disablePlayerOption('sofascore')"
    >
      <iframe
        v-if="item.evento.sofaScoreId"
        class="viewEventoFloatingFrame"
        frameborder="0"
        scrolling="no"
        :src="'/sofascore/' + item.evento.sofaScoreId"
      ></iframe>
      <div
        v-else
        class="viewEventoFloatingHtml"
        v-html="item.evento.sofaScore"
      ></div>
    </floating-content-panel>

    <floating-content-panel
      v-if="
        !previewMode &&
        propSofaScore &&
        item.evento &&
        item.evento.williamHillId &&
        options.williamhill &&
        options.williamhillFloat
      "
      title="William Hill"
      icon-class="fa fa-bar-chart"
      storage-key="viewEventoFloatingWilliamhill"
      :initial-x="williamFloatingInitialX"
      :initial-y="90"
      :initial-width="600"
      :initial-height="520"
      :allow-bottom-overflow="true"
      :z-index="1062"
      @close="disablePlayerOption('williamhill')"
    >
      <iframe
        class="viewEventoFloatingFrame"
        frameborder="0"
        scrolling="auto"
        :src="
          'https://score.kwddw.com/scoreboards/app/football/index.html?eventId=' +
          william(item.evento.williamHillId) +
          '&sport=football&locale=pt-pt'
        "
      ></iframe>
    </floating-content-panel>
    <div
      class="row rowFuncoes"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ms' && false == true
            ? 'block'
            : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <button @click="fullScreen()">Tela Cheia</button>
      </div>
    </div>
    <div class="row" v-if="!item.erro">
      <div
        class="col-md-12 text-center"
        style="padding: 0"
        v-if="
          propSofaScore &&
          item.evento &&
          (item.evento.sofaScoreId || item.evento.williamHillId)
        "
      >
        <div
          v-if="
            item.evento.sofaScoreId &&
            options.sofascore &&
            !options.sofascoreFloat
          "
          style="height: 86px;"
        >
          <iframe
            width="100%"
            height="86"
            frameborder="0"
            scrolling="no"
            :src="'/sofascore/' + item.evento.sofaScoreId"
          ></iframe>
        </div>
        <div
          v-if="
            item.evento.williamHillId &&
            options.williamhill &&
            !options.williamhillFloat
          "
        >
          <iframe
            width="100%"
            height="700"
            frameborder="0"
            scrolling="no"
            :src="
              'https://score.kwddw.com/scoreboards/app/football/index.html?eventId=' +
              william(item.evento.williamHillId) +
              '&sport=football&locale=pt-pt'
            "
          ></iframe>
        </div>
      </div>
    </div>
    <div class="row" v-if="!item.erro">
      <div
        class="col-md-12 text-center"
        style="padding: 0"
        v-if="
          propSofaScore &&
          options.sofascore &&
          !options.sofascoreFloat &&
          item.evento &&
          item.evento.sofaScore
        "
      >
        <div v-html="item.evento.sofaScore"></div>
      </div>
    </div>
    <div class="row" v-if="item.erro">
      <div class="col-md-12 text-center" style="margin-top: 40px">
        <h5 style="color: white">{{ item.erroMensagem }}</h5>
      </div>
    </div>
    <i
      v-if="retornaSite() == '7live'"
      class="d234fdsa2"
      :style="{ top: markTop + 'px' }"
      >{{ markText }}</i
    >

    <button
      v-if="
        !previewMode &&
        item.evento &&
        !item.erro &&
        (retornaSite() == 'Weddbets' || retornaSite() == 'Bll')
      "
      type="button"
      class="viewEventoOptionsButton"
      :class="{
        active: menuOpen,
        visible: playerOptionsButtonVisible || menuOpen,
      }"
      :aria-expanded="menuOpen ? 'true' : 'false'"
      aria-controls="viewEventoOptionsPanel"
      @focus="showPlayerOptionsButton"
      @click="toggleMenu"
    >
      <i class="fa fa-sliders" aria-hidden="true"></i>
      <span>Opções</span>
    </button>

    <div
      v-if="menuOpen && !previewMode"
      class="viewEventoOptionsBackdrop"
      @click.self="closePlayerOptions"
    >
      <aside
        id="viewEventoOptionsPanel"
        class="viewEventoOptionsPanel"
        role="dialog"
        aria-modal="false"
        aria-labelledby="viewEventoOptionsTitle"
      >
        <header class="viewEventoOptionsHeader">
          <div>
            <i class="fa fa-sliders" aria-hidden="true"></i>
            <h2 id="viewEventoOptionsTitle">Opções do player</h2>
          </div>
          <button
            type="button"
            title="Fechar opções"
            aria-label="Fechar opções"
            @click="closePlayerOptions"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </header>

        <section
          v-if="
            item.evento &&
            (item.evento.sofaScoreId ||
              item.evento.sofaScore ||
              item.evento.williamHillId)
          "
          class="viewEventoOptionsGroup"
          aria-labelledby="viewEventoContentOptions"
        >
          <h3 id="viewEventoContentOptions">Conteúdo</h3>

          <div
            v-if="item.evento.sofaScoreId || item.evento.sofaScore"
            class="viewEventoOptionBlock"
          >
            <div class="viewEventoOptionRow">
              <div>
                <i class="fa fa-line-chart" aria-hidden="true"></i>
                <strong>SofaScore</strong>
              </div>
              <button
                type="button"
                role="switch"
                class="viewEventoOptionSwitch"
                :class="{ active: options.sofascore }"
                :aria-checked="options.sofascore ? 'true' : 'false'"
                aria-label="Exibir SofaScore"
                @click="togglePlayerOption('sofascore')"
              >
                <span></span>
              </button>
            </div>
            <div
              v-if="options.sofascore"
              class="viewEventoOptionMode"
              role="group"
              aria-label="Modo de exibição do SofaScore"
            >
              <button
                type="button"
                :class="{ active: !options.sofascoreFloat }"
                @click="setPlayerOptionMode('sofascore', false)"
              >
                <i class="fa fa-columns" aria-hidden="true"></i>
                Na página
              </button>
              <button
                type="button"
                :class="{ active: options.sofascoreFloat }"
                @click="setPlayerOptionMode('sofascore', true)"
              >
                <i class="fa fa-window-restore" aria-hidden="true"></i>
                Flutuante
              </button>
            </div>
          </div>

          <div
            v-if="item.evento.williamHillId"
            class="viewEventoOptionBlock"
          >
            <div class="viewEventoOptionRow">
              <div>
                <i class="fa fa-bar-chart" aria-hidden="true"></i>
                <strong>William Hill</strong>
              </div>
              <button
                type="button"
                role="switch"
                class="viewEventoOptionSwitch"
                :class="{ active: options.williamhill }"
                :aria-checked="options.williamhill ? 'true' : 'false'"
                aria-label="Exibir William Hill"
                @click="togglePlayerOption('williamhill')"
              >
                <span></span>
              </button>
            </div>
            <div
              v-if="options.williamhill"
              class="viewEventoOptionMode"
              role="group"
              aria-label="Modo de exibição do William Hill"
            >
              <button
                type="button"
                :class="{ active: !options.williamhillFloat }"
                @click="setPlayerOptionMode('williamhill', false)"
              >
                <i class="fa fa-columns" aria-hidden="true"></i>
                Na página
              </button>
              <button
                type="button"
                :class="{ active: options.williamhillFloat }"
                @click="setPlayerOptionMode('williamhill', true)"
              >
                <i class="fa fa-window-restore" aria-hidden="true"></i>
                Flutuante
              </button>
            </div>
          </div>
        </section>

        <section
          class="viewEventoOptionsGroup"
          aria-labelledby="viewEventoReplayOptions"
        >
          <h3 id="viewEventoReplayOptions">Reprodução</h3>
          <div class="viewEventoOptionBlock viewEventoVideoFitOption">
            <div class="viewEventoOptionRow">
              <div>
                <i class="fa fa-crop" aria-hidden="true"></i>
                <strong>Enquadramento</strong>
              </div>
            </div>
            <div
              class="viewEventoOptionMode"
              role="group"
              aria-label="Enquadramento do vídeo"
            >
              <button
                type="button"
                :class="{ active: options.videoFit == 'original' }"
                @click="setVideoFit('original')"
              >
                <i class="fa fa-picture-o" aria-hidden="true"></i>
                Original
              </button>
              <button
                type="button"
                :class="{ active: options.videoFit == 'fill' }"
                @click="setVideoFit('fill')"
              >
                <i class="fa fa-expand" aria-hidden="true"></i>
                Expandir
              </button>
              <button
                type="button"
                :class="{ active: options.videoFit == 'contain' }"
                @click="setVideoFit('contain')"
              >
                <i class="fa fa-compress" aria-hidden="true"></i>
                Proporcional
              </button>
            </div>
          </div>
          <div class="viewEventoOptionRow">
            <div>
              <i class="fa fa-history" aria-hidden="true"></i>
              <strong>Replay</strong>
            </div>
            <button
              type="button"
              role="switch"
              class="viewEventoOptionSwitch"
              :class="{ active: options.replay }"
              :aria-checked="options.replay ? 'true' : 'false'"
              aria-label="Habilitar replay"
              @click="toggleReplay"
            >
              <span></span>
            </button>
          </div>

        </section>
      </aside>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import { apiOpenVidu } from "@/services/apiOpenVidu.js";
import { apiAnt } from "@/services/apiAnt.js";
import { apiFlashphoner } from "@/services/apiFlashphoner.js";
import { apiMS } from "@/services/apiMS.js";
import FloatingContentPanel from "@/components/FloatingContentPanel.vue";
import util from "../includes/util.js";

export default {
  name: "ViewEvento",
  components: { FloatingContentPanel },
  props: {
    propSofaScore: { type: Boolean, default: true },
    eventoId: { type: String, default: "" },
    canal: { type: [String, Number], default: "" },
    clean: { type: Boolean, default: false },
    embedded: { type: Boolean, default: false },
    preview: { type: Boolean, default: false },
  },
  data: function () {
    return {
      item: {
        evento: null,
        erro: false,
        token: "",
        erroMensagem: "",
      },
      lastWk: "",
      viewEventoOpen: {},
      menuOpen: false,
      playerOptionsButtonVisible: true,
      options: {
        sofascore: false,
        sofascoreFloat: false,
        williamhill: false,
        williamhillFloat: false,
        videoFit: "original",
        replay: false,
      },
      replayLoad: false,
      replayReady: false,
      replayStatus: "Preparando replay...",
      replayDelaySeconds: 2,
      replaySize: {
        width: 420,
        isResizing: false,
        startX: 0,
        startWidth: 420,
        startRight: 0,
      },
      replayPosition: {
        x: null,
        y: null,
        isDragging: false,
        startX: 0,
        startY: 0,
        startLeft: 0,
        startTop: 0,
      },
      sessionViewInterval: null,
    };
  },
  created() {
    this.replayAnimationFrame = null;
    this.replayBuffer = [];
    this.replayCaptureCanvas = null;
    this.replayCaptureInProgress = false;
    this.replayCaptureError = false;
    this.replayLastCapture = 0;
    this.replayOutputWidth = 0;
    this.replayOutputHeight = 0;
    this.playerOptionsButtonTimer = null;
  },
  methods: {
    loadPlayerOptionsPreferences() {
      try {
        const savedOptions = JSON.parse(
          localStorage.getItem("viewEventoPlayerOptions")
        );

        if (!savedOptions || typeof savedOptions !== "object") {
          return;
        }

        [
          "sofascore",
          "sofascoreFloat",
          "williamhill",
          "williamhillFloat",
          "replay",
        ].forEach((option) => {
          if (typeof savedOptions[option] === "boolean") {
            this.options[option] = savedOptions[option];
          }
        });

        if (["original", "fill", "contain"].includes(savedOptions.videoFit)) {
          this.options.videoFit = savedOptions.videoFit;
        }

        if (this.options.replay) {
          this.$nextTick(this.startReplay);
        }
      } catch (error) {
        return;
      }
    },
    savePlayerOptionsPreferences() {
      try {
        localStorage.setItem(
          "viewEventoPlayerOptions",
          JSON.stringify({
            sofascore: this.options.sofascore,
            sofascoreFloat: this.options.sofascoreFloat,
            williamhill: this.options.williamhill,
            williamhillFloat: this.options.williamhillFloat,
            videoFit: this.options.videoFit,
            replay: this.options.replay,
          })
        );
      } catch (error) {
        // As opções continuam funcionando quando o storage não está disponível.
      }
    },
    togglePlayerOption(option) {
      this.options[option] = !this.options[option];
      this.savePlayerOptionsPreferences();
    },
    disablePlayerOption(option) {
      this.options[option] = false;
      this.savePlayerOptionsPreferences();
    },
    setPlayerOptionMode(option, floating) {
      this.options[option + "Float"] = floating;
      this.savePlayerOptionsPreferences();
    },
    setVideoFit(videoFit) {
      this.options.videoFit = videoFit;
      this.savePlayerOptionsPreferences();
    },
    loadReplayPreferences() {
      try {
        const savedDelay = Number(localStorage.getItem("viewEventoReplayDelay"));
        const savedWidthValue = localStorage.getItem("viewEventoReplayWidth");
        const savedWidth = Number(savedWidthValue);
        const savedPositionValue = localStorage.getItem(
          "viewEventoReplayPosition"
        );

        if ([1, 2, 3, 4, 5].includes(savedDelay)) {
          this.replayDelaySeconds = savedDelay;
        }

        if (savedWidthValue !== null && Number.isFinite(savedWidth)) {
          this.replaySize.width = Math.max(280, Math.min(720, savedWidth));
        }

        if (savedPositionValue) {
          const savedPosition = JSON.parse(savedPositionValue);
          if (
            Number.isFinite(savedPosition.x) &&
            Number.isFinite(savedPosition.y)
          ) {
            this.replayPosition.x = savedPosition.x;
            this.replayPosition.y = savedPosition.y;
          }
        }
      } catch (error) {
        return;
      }
    },
    changeReplayDelay() {
      if (![1, 2, 3, 4, 5].includes(this.replayDelaySeconds)) {
        this.replayDelaySeconds = 2;
      }

      try {
        localStorage.setItem(
          "viewEventoReplayDelay",
          this.replayDelaySeconds.toString()
        );
      } catch (error) {
        // A preferência é opcional; o replay continua funcionando sem storage.
      }

      this.disposeReplayBuffer();
      this.replayReady = false;
      this.replayStatus = "Preparando replay...";

      const outputCanvas = this.$refs.replayCanvas;
      if (outputCanvas) {
        outputCanvas
          .getContext("2d", { alpha: false })
          .clearRect(0, 0, outputCanvas.width, outputCanvas.height);
      }
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;

      if (this.menuOpen) {
        clearTimeout(this.playerOptionsButtonTimer);
      } else {
        this.showPlayerOptionsButton();
      }
    },
    closePlayerOptions() {
      this.menuOpen = false;
      this.showPlayerOptionsButton();
    },
    showPlayerOptionsButton() {
      this.playerOptionsButtonVisible = true;
      clearTimeout(this.playerOptionsButtonTimer);

      if (this.menuOpen) {
        return;
      }

      this.playerOptionsButtonTimer = setTimeout(() => {
        this.playerOptionsButtonVisible = false;
      }, 2800);
    },
    handlePlayerOptionsKeydown(event) {
      if (event.key == "Escape" && this.menuOpen) {
        this.closePlayerOptions();
      }
    },
    retornaSite() {
      return this.$site;
    },
    async carregarItem1(id) {
      console.log(id);
    },
    async carregarItem(id) {
      var parametros = "";

      if (this.canal !== "" && this.canal !== null && this.canal !== undefined) {
        parametros = "?canal=" + this.canal;
      } else if (this.$route.query.canal) {
        parametros = "?canal=" + this.$route.query.canal;
      }

      const response = await api.get("/evento/view/" + id + parametros);

      //* Verifica se econtrou
      if (response.data.erro == false && response.data.itens.length > 0) {
        this.viewEventoOpen = response.data.itens[0];

        let tituloEventoPre = "";

        if (
          this.$sessao.usuario.tipoUsuario == "Administrador" ||
          this.$sessao.usuario.tipoUsuario == "Apresentador"
        ) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.viewEventoOpen,
              "dataHora"
            ) &&
            Object.prototype.hasOwnProperty.call(
              this.viewEventoOpen,
              "dataMinuto"
            )
          ) {
            tituloEventoPre =
              this.viewEventoOpen.dataHora.toString().padStart(2, "0") +
              ":" +
              this.viewEventoOpen.dataMinuto.toString().padStart(2, "0") +
              " - ";
          }
        }

        if (!this.embedded && this.$route.query.canal) {
          document.title =
            "(" +
            this.$route.query.canal +
            ") " +
            tituloEventoPre +
            this.viewEventoOpen.nome;
        } else if (!this.embedded) {
          document.title = tituloEventoPre + this.viewEventoOpen.nome;
        }

        this.item.evento = this.viewEventoOpen;
        this.item.evento.servidorTipo = this.item.evento.servidorTipo
          ? this.item.evento.servidorTipo
          : "openvidu";
        this.item.erro = false;

        if (this.item.evento.servidorTipo == "openvidu") {
          apiOpenVidu.entrarSessaoB(this.viewEventoOpen);
        } else if (this.item.evento.servidorTipo == "ant") {
          apiAnt.view(this.item.evento);
        } else if (this.item.evento.servidorTipo == "sh") {
          apiFlashphoner.initStream();
          apiFlashphoner.connectPlay(
            this.viewEventoOpen.key,
            this.item.evento,
            this.item.evento.canal
          );
        } else if (this.item.evento.servidorTipo == "ms") {
          apiMS.setUrl(this.item.evento.servidor);
          apiMS.setToken(this.item.evento.msToken);

          await apiMS.connect({ subscribe: true });
        }
      } else {
        this.item.erro = true;
        this.item.erroMensagem = response.data.mensagem;
      }
    },
    async sessionView() {
      var body = {
        token: this.viewEventoOpen.sessaoView,
      };

      try {
        await api.put("/sessaoView", body);
      } catch (error) {
        console.log(error);
      }
    },
    william(id) {
      return id.replace("OB_EV", "");
    },
    getView() {
      if (
        this.clean ||
        (this.$route.query.view && this.$route.query.view == "clean") ||
        this.$site == "7live"
      ) {
        return false;
      }

      return true;
    },
    apiFlashphoner() {
      return apiFlashphoner;
    },
    fullScreen() {
      if (!document.fullscreenElement) {
        document.getElementById("frameVideo").requestFullscreen();
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    },
    createWatermark() {
      const videoContainer = document.getElementById("msPlayVideo").parentNode;

      if (videoContainer) {
        const watermark = document.createElement("div");
        watermark.innerHTML =
          this.$sessao.usuario.site + "<br />" + this.$sessao.usuario.email;

        watermark.className = this.lastWk;
        watermark.style.position = "absolute";
        watermark.style.color = "rgba(218, 165, 255, 0.5)";
        watermark.style.backgroundColor = "rgba(0, 0, 0, 0.0)";
        watermark.style.padding = "5px 10px";
        watermark.style.borderRadius = "5px";
        watermark.style.pointerEvents = "none";
        watermark.style.zIndex = "10";
        watermark.style.fontSize = "10px";
        watermark.style.fontWeight = "bold";

        const x = Math.random() * (videoContainer.clientWidth - 164);
        const y = Math.random() * (videoContainer.clientHeight - 40);

        watermark.style.left = `${x}px`;
        watermark.style.top = `${y}px`;

        videoContainer.appendChild(watermark);
      }
    },
    ensureWatermark() {
      if (this.lastWk !== "") {
        const watermarks = document.querySelectorAll("." + this.lastWk);

        // Remove cada elemento selecionado
        watermarks.forEach((watermark) => {
          watermark.remove();
        });
      }

      this.lastWk = util.guidGenerator().replace(/[^a-zA-Z]/g, "");

      const videoContainer = document.getElementById("msPlayVideo").parentNode;

      if (videoContainer) {
        this.createWatermark();
      }
    },
    toggleReplay() {
      if (this.options.replay) {
        this.stopReplay();
        this.savePlayerOptionsPreferences();
        return;
      }

      this.options.replay = true;
      this.savePlayerOptionsPreferences();
      this.replayReady = false;
      this.replayStatus = "Preparando replay...";
      this.$nextTick(this.startReplay);
    },
    startReplay() {
      this.releaseReplay();
      this.replayLoad = true;
      this.replayCaptureCanvas = document.createElement("canvas");
      this.replayCaptureInProgress = false;
      this.replayCaptureError = false;
      this.replayLastCapture = 0;
      this.replayOutputWidth = 0;
      this.replayOutputHeight = 0;
      this.replayAnimationFrame = window.requestAnimationFrame(
        this.processReplayFrame
      );
      this.normalizeReplayPosition();
    },
    getReplaySourceVideo() {
      if (!this.item.evento) {
        return null;
      }

      if (this.item.evento.servidorTipo == "ms") {
        return this.$refs.msVideo || null;
      }

      if (this.item.evento.servidorTipo == "ant") {
        return this.$refs.antVideo || null;
      }

      if (this.item.evento.servidorTipo == "sh") {
        return this.$refs.flashVideo || null;
      }

      if (this.item.evento.servidorTipo == "openvidu") {
        return this.$el.querySelector("#subscriber video");
      }

      return this.$el.querySelector("video");
    },
    processReplayFrame(now) {
      if (!this.options.replay) {
        return;
      }

      const captureInterval = 1000 / 30;
      const sourceVideo = this.getReplaySourceVideo();
      const outputCanvas = this.$refs.replayCanvas;

      if (
        !sourceVideo ||
        !outputCanvas ||
        sourceVideo.readyState < 2 ||
        !sourceVideo.videoWidth ||
        !sourceVideo.videoHeight
      ) {
        this.replayStatus = "Aguardando vídeo original...";
        this.replayAnimationFrame = window.requestAnimationFrame(
          this.processReplayFrame
        );
        return;
      }

      const width = Math.min(sourceVideo.videoWidth, 640);
      const height = Math.max(
        1,
        Math.round((sourceVideo.videoHeight / sourceVideo.videoWidth) * width)
      );

      if (
        this.replayOutputWidth !== width ||
        this.replayOutputHeight !== height
      ) {
        this.disposeReplayBuffer();
        this.replayCaptureCanvas.width = width;
        this.replayCaptureCanvas.height = height;
        outputCanvas.width = width;
        outputCanvas.height = height;
        this.replayOutputWidth = width;
        this.replayOutputHeight = height;
        this.replayReady = false;
      }

      if (
        !this.replayCaptureInProgress &&
        !this.replayCaptureError &&
        now - this.replayLastCapture >= captureInterval
      ) {
        this.replayLastCapture = now;
        this.captureReplayFrame(sourceVideo, now, width, height);
      }

      const targetTime = now - this.replayDelaySeconds * 1000;
      let delayedFrame = null;

      while (
        this.replayBuffer.length > 0 &&
        this.replayBuffer[0].capturedAt <= targetTime
      ) {
        if (delayedFrame) {
          this.disposeReplayImage(delayedFrame.image);
        }
        delayedFrame = this.replayBuffer.shift();
      }

      if (delayedFrame) {
        outputCanvas
          .getContext("2d", { alpha: false })
          .drawImage(delayedFrame.image, 0, 0, width, height);
        this.disposeReplayImage(delayedFrame.image);
        this.replayReady = true;
        this.replayStatus = "";
      } else if (!this.replayReady && !this.replayCaptureError) {
        this.replayStatus = "Preparando replay...";
      }

      this.replayAnimationFrame = window.requestAnimationFrame(
        this.processReplayFrame
      );
    },
    async captureReplayFrame(sourceVideo, capturedAt, width, height) {
      this.replayCaptureInProgress = true;
      const captureCanvas = this.replayCaptureCanvas;

      try {
        let image;

        if (typeof window.createImageBitmap == "function") {
          try {
            image = await window.createImageBitmap(
              sourceVideo,
              0,
              0,
              sourceVideo.videoWidth,
              sourceVideo.videoHeight,
              {
                resizeWidth: width,
                resizeHeight: height,
                resizeQuality: "low",
              }
            );
          } catch (error) {
            const captureContext = captureCanvas.getContext("2d", {
              alpha: false,
            });
            captureContext.drawImage(sourceVideo, 0, 0, width, height);
            image = await window.createImageBitmap(captureCanvas);
          }
        } else {
          image = document.createElement("canvas");
          image.width = width;
          image.height = height;
          image
            .getContext("2d", { alpha: false })
            .drawImage(sourceVideo, 0, 0, width, height);
        }

        if (!this.options.replay) {
          this.disposeReplayImage(image);
          return;
        }

        this.replayBuffer.push({ capturedAt, image });

        const maximumFrames = (this.replayDelaySeconds + 1) * 30;
        while (this.replayBuffer.length > maximumFrames) {
          const discardedFrame = this.replayBuffer.shift();
          this.disposeReplayImage(discardedFrame.image);
        }
      } catch (error) {
        this.replayCaptureError = true;
        this.replayStatus = "Replay indisponível para este vídeo.";
        console.error("Não foi possível gerar o replay.", error);
      } finally {
        this.replayCaptureInProgress = false;
      }
    },
    disposeReplayImage(image) {
      if (image && typeof image.close == "function") {
        image.close();
      }
    },
    disposeReplayBuffer() {
      this.replayBuffer.forEach((frame) => {
        this.disposeReplayImage(frame.image);
      });
      this.replayBuffer = [];
    },
    releaseReplay() {
      if (this.replayAnimationFrame !== null) {
        window.cancelAnimationFrame(this.replayAnimationFrame);
      }

      this.replayAnimationFrame = null;
      this.disposeReplayBuffer();
      this.replayCaptureCanvas = null;
      this.replayCaptureInProgress = false;
      this.replayLoad = false;
    },
    stopReplay() {
      this.stopReplayDrag();
      this.stopReplayResize();
      this.options.replay = false;
      this.replayReady = false;
      this.replayStatus = "Preparando replay...";
      this.releaseReplay();
    },
    startReplayDrag(event) {
      if (
        document.fullscreenElement ||
        event.target.closest("button, select, .viewEventoReplayResize")
      ) {
        return;
      }

      const replayWindow = this.$refs.replayWindow;
      if (!replayWindow) {
        return;
      }

      const pointer = event.touches ? event.touches[0] : event;
      const bounds = replayWindow.getBoundingClientRect();
      this.replayPosition.isDragging = true;
      this.replayPosition.startX = pointer.clientX;
      this.replayPosition.startY = pointer.clientY;
      this.replayPosition.startLeft = bounds.left;
      this.replayPosition.startTop = bounds.top;
      this.replayPosition.x = bounds.left;
      this.replayPosition.y = bounds.top;

      document.addEventListener("mousemove", this.onReplayDrag);
      document.addEventListener("mouseup", this.stopReplayDrag);
      document.addEventListener("touchmove", this.onReplayDrag, {
        passive: false,
      });
      document.addEventListener("touchend", this.stopReplayDrag);
      event.preventDefault();
    },
    onReplayDrag(event) {
      if (!this.replayPosition.isDragging) {
        return;
      }

      const replayWindow = this.$refs.replayWindow;
      if (!replayWindow) {
        return;
      }

      const pointer = event.touches ? event.touches[0] : event;
      const bounds = replayWindow.getBoundingClientRect();
      const margin = 12;
      const maximumX = Math.max(margin, window.innerWidth - bounds.width - margin);
      const maximumY = Math.max(
        margin,
        window.innerHeight - bounds.height - margin
      );
      const nextX =
        this.replayPosition.startLeft +
        pointer.clientX -
        this.replayPosition.startX;
      const nextY =
        this.replayPosition.startTop +
        pointer.clientY -
        this.replayPosition.startY;

      this.replayPosition.x = Math.max(margin, Math.min(maximumX, nextX));
      this.replayPosition.y = Math.max(margin, Math.min(maximumY, nextY));
      event.preventDefault();
    },
    stopReplayDrag() {
      if (!this.replayPosition.isDragging) {
        return;
      }

      this.replayPosition.isDragging = false;
      document.removeEventListener("mousemove", this.onReplayDrag);
      document.removeEventListener("mouseup", this.stopReplayDrag);
      document.removeEventListener("touchmove", this.onReplayDrag);
      document.removeEventListener("touchend", this.stopReplayDrag);
      this.saveReplayPosition();
    },
    normalizeReplayPosition() {
      const replayWindow = this.$refs.replayWindow;
      if (
        !replayWindow ||
        !Number.isFinite(this.replayPosition.x) ||
        !Number.isFinite(this.replayPosition.y)
      ) {
        return;
      }

      const bounds = replayWindow.getBoundingClientRect();
      const margin = 12;
      const maximumX = Math.max(margin, window.innerWidth - bounds.width - margin);
      const maximumY = Math.max(
        margin,
        window.innerHeight - bounds.height - margin
      );
      this.replayPosition.x = Math.max(
        margin,
        Math.min(maximumX, this.replayPosition.x)
      );
      this.replayPosition.y = Math.max(
        margin,
        Math.min(maximumY, this.replayPosition.y)
      );
    },
    saveReplayPosition() {
      if (
        !Number.isFinite(this.replayPosition.x) ||
        !Number.isFinite(this.replayPosition.y)
      ) {
        return;
      }

      try {
        localStorage.setItem(
          "viewEventoReplayPosition",
          JSON.stringify({
            x: Math.round(this.replayPosition.x),
            y: Math.round(this.replayPosition.y),
          })
        );
      } catch (error) {
        return;
      }
    },
    startReplayResize(event) {
      if (document.fullscreenElement) {
        return;
      }

      this.stopReplayDrag();
      const pointer = event.touches ? event.touches[0] : event;
      const replayWindow = this.$refs.replayWindow;
      const bounds = replayWindow.getBoundingClientRect();
      this.replaySize.isResizing = true;
      this.replaySize.startX = pointer.clientX;
      this.replaySize.startWidth = bounds.width;
      this.replaySize.startRight = bounds.right;
      this.replayPosition.x = bounds.left;
      this.replayPosition.y = bounds.top;

      document.addEventListener("mousemove", this.onReplayResize);
      document.addEventListener("mouseup", this.stopReplayResize);
      document.addEventListener("touchmove", this.onReplayResize, {
        passive: false,
      });
      document.addEventListener("touchend", this.stopReplayResize);
      event.preventDefault();
    },
    onReplayResize(event) {
      if (!this.replaySize.isResizing) {
        return;
      }

      const pointer = event.touches ? event.touches[0] : event;
      const maximumWidth = Math.max(
        220,
        Math.min(720, this.replaySize.startRight - 12)
      );
      const minimumWidth = Math.min(280, maximumWidth);
      const delta = this.replaySize.startX - pointer.clientX;
      this.replaySize.width = Math.max(
        minimumWidth,
        Math.min(maximumWidth, this.replaySize.startWidth + delta)
      );
      this.replayPosition.x = this.replaySize.startRight - this.replaySize.width;
      event.preventDefault();
    },
    stopReplayResize() {
      if (!this.replaySize.isResizing) {
        return;
      }

      this.replaySize.isResizing = false;
      document.removeEventListener("mousemove", this.onReplayResize);
      document.removeEventListener("mouseup", this.stopReplayResize);
      document.removeEventListener("touchmove", this.onReplayResize);
      document.removeEventListener("touchend", this.stopReplayResize);

      try {
        localStorage.setItem(
          "viewEventoReplayWidth",
          Math.round(this.replaySize.width).toString()
        );
      } catch (error) {
        return;
      }

      this.saveReplayPosition();
    },
    fullScreenReplay() {
      const replayWindow = this.$refs.replayWindow;

      if (!replayWindow) {
        return;
      }

      if (!document.fullscreenElement) {
        replayWindow.requestFullscreen();
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    },
  },
  mounted() {
    //var thisCall = this;

    this.loadReplayPreferences();
    this.showPlayerOptionsButton();
    window.addEventListener("resize", this.normalizeReplayPosition);
    document.addEventListener("keydown", this.handlePlayerOptionsKeydown);

    if (!this.embedded) {
      document.body.style.backgroundColor = "black";
      document.body.style.overflow = "hidden";
      document.getElementById("app").style["margin-top"] = "0";
      document.addEventListener("contextmenu", function (e) {
        e.preventDefault();
      });
    }

    const cleanView =
      this.clean ||
      (this.$route.query.view && this.$route.query.view == "clean");

    if (cleanView) {
      this.options.williamhill = false;
      this.options.sofascore = false;
    } else {
      this.options.williamhill = true;
      this.options.sofascore = true;
      this.loadPlayerOptionsPreferences();
    }

    this.carregarItem(this.eventoId || this.$route.params.id);

    this.sessionViewInterval = setInterval(() => {
      this.sessionView();
    }, 15000);

    /*setInterval(function () {
      thisCall.ensureWatermark();
    }, 10000);*/

    this.markText = this.$sessao.usuario.email;
  },
  beforeDestroy() {
    if (this.sessionViewInterval) {
      clearInterval(this.sessionViewInterval);
    }

    this.stopReplayResize();
    this.releaseReplay();
    clearTimeout(this.playerOptionsButtonTimer);
    window.removeEventListener("resize", this.normalizeReplayPosition);
    document.removeEventListener("keydown", this.handlePlayerOptionsKeydown);

    try {
      apiMS.disconnect();
    } catch (e) {
      console.log(e);
    }
  },
  computed: {
    williamFloatingInitialX() {
      return Math.max(16, window.innerWidth - 616);
    },
    replayWindowStyle() {
      const style = {
        "--replay-width": this.replaySize.width + "px",
      };

      if (
        Number.isFinite(this.replayPosition.x) &&
        Number.isFinite(this.replayPosition.y)
      ) {
        style.left = this.replayPosition.x + "px";
        style.top = this.replayPosition.y + "px";
        style.right = "auto";
        style.bottom = "auto";
      }

      return style;
    },
    previewMode() {
      return this.preview || (this.$route && this.$route.query && this.$route.query.preview === '1');
    },
    audioMudo: function () {
      return (
        this.$sessao.usuario.tipoUsuario == "Administrador" ||
        this.$sessao.usuario.tipoUsuario == "Apresentador"
      );
    },
  },
};
</script>

<style>
.viewEventoRoot {
  min-height: 100vh;
}

.viewEventoRoot.videoFitFill > .viewEventoPlayerSurface,
.viewEventoRoot.videoFitContain > .viewEventoPlayerSurface {
  background: #000000;
  height: 100vh;
  height: 100dvh;
}

.viewEventoRoot.videoFitFill > .viewEventoPlayerSurface > .col-md-12,
.viewEventoRoot.videoFitFill > .viewEventoPlayerSurface #subscriber,
.viewEventoRoot.videoFitFill > .viewEventoPlayerSurface #playFlash,
.viewEventoRoot.videoFitContain > .viewEventoPlayerSurface > .col-md-12,
.viewEventoRoot.videoFitContain > .viewEventoPlayerSurface #subscriber,
.viewEventoRoot.videoFitContain > .viewEventoPlayerSurface #playFlash {
  height: 100%;
}

.viewEventoRoot.videoFitFill > .viewEventoPlayerSurface video,
.viewEventoRoot.videoFitContain > .viewEventoPlayerSurface video {
  height: 100%;
  max-height: 100%;
  object-position: center center;
  width: 100%;
}

.viewEventoRoot.videoFitFill > .viewEventoPlayerSurface video {
  object-fit: fill;
}

.viewEventoRoot.videoFitContain > .viewEventoPlayerSurface video {
  background: #000000;
  object-fit: contain;
}

.viewEventoOptionsButton {
  align-items: center;
  background: rgba(25, 32, 37, 0.94);
  border: 1px solid #58646c;
  border-radius: 4px;
  color: #f4f6f7;
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  font-weight: 600;
  gap: 7px;
  height: 38px;
  opacity: 0;
  padding: 0 11px;
  pointer-events: none;
  position: fixed;
  right: 14px;
  top: 14px;
  transform: translateY(-6px);
  transition: opacity 0.18s ease, transform 0.18s ease,
    background-color 0.18s ease;
  z-index: 1070;
}

.viewEventoOptionsButton.visible,
.viewEventoOptionsButton:focus-visible {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.viewEventoOptionsButton:hover,
.viewEventoOptionsButton.active {
  background: #303a41;
  border-color: #74818a;
}

.viewEventoOptionsButton:focus-visible,
.viewEventoOptionsHeader button:focus-visible,
.viewEventoOptionSwitch:focus-visible {
  outline: 2px solid #37b982;
  outline-offset: 2px;
}

.viewEventoOptionsBackdrop {
  inset: 0;
  position: fixed;
  z-index: 1080;
}

.viewEventoOptionsPanel {
  background: #151b1f;
  border: 1px solid #455159;
  border-radius: 6px;
  box-shadow: 0 16px 42px rgba(0, 0, 0, 0.52);
  color: #edf1f3;
  max-height: calc(100vh - 72px);
  overflow-y: auto;
  position: fixed;
  right: 14px;
  top: 58px;
  width: min(300px, calc(100vw - 28px));
}

.viewEventoOptionsHeader {
  align-items: center;
  border-bottom: 1px solid #364148;
  display: flex;
  height: 46px;
  justify-content: space-between;
  padding: 0 8px 0 14px;
}

.viewEventoOptionsHeader > div {
  align-items: center;
  display: inline-flex;
  gap: 8px;
}

.viewEventoOptionsHeader > div > i {
  color: #42bd89;
  font-size: 13px;
}

.viewEventoOptionsHeader h2 {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  margin: 0;
}

.viewEventoOptionsHeader button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 3px;
  color: #b9c2c7;
  cursor: pointer;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  padding: 0;
  width: 32px;
}

.viewEventoOptionsHeader button:hover {
  background: #2a343a;
  color: #ffffff;
}

.viewEventoOptionsGroup {
  border-bottom: 1px solid #303a40;
  padding: 11px 14px 6px;
}

.viewEventoOptionsGroup:last-child {
  border-bottom: 0;
}

.viewEventoOptionsGroup h3 {
  color: #8e9ba3;
  font-size: 9px;
  font-weight: 700;
  margin: 0 0 4px;
  text-transform: uppercase;
}

.viewEventoOptionRow {
  align-items: center;
  border-bottom: 1px solid #293238;
  display: flex;
  height: 46px;
  justify-content: space-between;
}

.viewEventoOptionRow:last-child {
  border-bottom: 0;
}

.viewEventoOptionRow > div {
  align-items: center;
  display: inline-flex;
  gap: 9px;
}

.viewEventoOptionRow > div > i {
  color: #9ba7ad;
  font-size: 12px;
  text-align: center;
  width: 17px;
}

.viewEventoOptionRow strong {
  font-size: 12px;
  font-weight: 500;
}

.viewEventoOptionSwitch {
  background: #3b454b;
  border: 1px solid #566168;
  border-radius: 10px;
  cursor: pointer;
  height: 20px;
  padding: 0;
  position: relative;
  transition: background-color 0.16s ease, border-color 0.16s ease;
  width: 36px;
}

.viewEventoOptionSwitch span {
  background: #e6eaec;
  border-radius: 50%;
  height: 14px;
  left: 2px;
  position: absolute;
  top: 2px;
  transition: transform 0.16s ease;
  width: 14px;
}

.viewEventoOptionSwitch.active {
  background: #169c68;
  border-color: #25b77c;
}

.viewEventoOptionSwitch.active span {
  transform: translateX(16px);
}

.viewEventoOptionBlock {
  border-bottom: 1px solid #293238;
  padding-bottom: 9px;
}

.viewEventoOptionBlock:last-child {
  border-bottom: 0;
}

.viewEventoOptionBlock .viewEventoOptionRow {
  border-bottom: 0;
}

.viewEventoVideoFitOption .viewEventoOptionRow {
  height: 38px;
}

.viewEventoOptionMode {
  background: #20282d;
  border: 1px solid #3e494f;
  border-radius: 4px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-left: 26px;
  overflow: hidden;
}

.viewEventoVideoFitOption .viewEventoOptionMode {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.viewEventoOptionMode button {
  align-items: center;
  background: transparent;
  border: 0;
  color: #aeb8bd;
  cursor: pointer;
  display: inline-flex;
  font-size: 10px;
  gap: 6px;
  height: 30px;
  justify-content: center;
  padding: 0 7px;
}

.viewEventoOptionMode button + button {
  border-left: 1px solid #3e494f;
}

.viewEventoOptionMode button.active {
  background: #344148;
  color: #ffffff;
}

.viewEventoOptionMode button:hover {
  background: #2b353b;
  color: #ffffff;
}

.viewEventoOptionMode button:focus-visible {
  outline: 2px solid #37b982;
  outline-offset: -2px;
}

.viewEventoFloatingFrame {
  border: 0;
  display: block;
  height: 100%;
  width: 100%;
}

.viewEventoFloatingHtml {
  min-height: 100%;
  width: 100%;
}

.viewEventoReplay {
  background: #090c0e;
  border: 1px solid #48535b;
  bottom: 18px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.48);
  max-width: calc(100vw - 36px);
  position: fixed;
  right: 18px;
  width: min(var(--replay-width, 420px), calc(100vw - 36px));
  z-index: 1060;
}

.viewEventoReplayResize {
  align-items: center;
  background: #2d373e;
  border: 1px solid #5c6870;
  color: #f4f6f7;
  cursor: ew-resize;
  display: flex;
  height: 22px;
  justify-content: center;
  left: -10px;
  position: absolute;
  top: -10px;
  user-select: none;
  width: 22px;
  z-index: 2;
}

.viewEventoReplayResize i {
  font-size: 10px;
  pointer-events: none;
}

.viewEventoReplayHeader {
  align-items: center;
  background: #1c2328;
  border-bottom: 1px solid #48535b;
  color: #f4f6f7;
  display: flex;
  height: 38px;
  justify-content: space-between;
  padding: 0 7px 0 12px;
  cursor: move;
  user-select: none;
}

.viewEventoReplayTitle {
  align-items: center;
  display: inline-flex;
  font-size: 12px;
  gap: 7px;
}

.viewEventoReplayTitle select {
  background: #364149;
  border: 1px solid #56636c;
  color: #f0f3f4;
  cursor: pointer;
  font-size: 10px;
  font-weight: 700;
  height: 24px;
  outline: none;
  padding: 0 17px 0 6px;
}

.viewEventoReplayHeader button {
  align-items: center;
  background: transparent;
  border: 0;
  color: #c9d0d4;
  cursor: pointer;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  padding: 0;
  width: 30px;
}

.viewEventoReplayHeader button:hover {
  background: #303940;
  color: #ffffff;
}

.viewEventoReplayBody {
  aspect-ratio: 16 / 9;
  background: #000000;
  position: relative;
  width: 100%;
}

.viewEventoReplayBody canvas {
  display: block;
  height: 100%;
  object-fit: contain;
  width: 100%;
}

.viewEventoReplayStatus {
  align-items: center;
  color: #d8dee2;
  display: flex;
  font-size: 11px;
  gap: 8px;
  inset: 0;
  justify-content: center;
  position: absolute;
}

.viewEventoReplay:fullscreen {
  border: 0;
  bottom: auto !important;
  height: 100vh;
  left: 0 !important;
  max-width: none;
  right: auto !important;
  top: 0 !important;
  width: 100vw;
}

.viewEventoReplay:fullscreen .viewEventoReplayResize {
  display: none;
}

.viewEventoReplay:fullscreen .viewEventoReplayBody {
  height: calc(100vh - 38px);
}

@media (max-width: 575px) {
  .viewEventoOptionsButton {
    right: 10px;
    top: 10px;
  }

  .viewEventoOptionsBackdrop {
    background: rgba(0, 0, 0, 0.36);
  }

  .viewEventoOptionsPanel {
    border-bottom: 0;
    border-left: 0;
    border-radius: 8px 8px 0 0;
    border-right: 0;
    bottom: 0;
    max-height: 76vh;
    padding-bottom: env(safe-area-inset-bottom);
    right: 0;
    top: auto;
    width: 100%;
  }

  .viewEventoOptionsHeader {
    height: 50px;
  }

  .viewEventoOptionRow {
    height: 50px;
  }

  .viewEventoReplay {
    bottom: 10px;
    max-width: calc(100vw - 20px);
    right: 10px;
    width: calc(100vw - 20px);
  }

  .viewEventoReplayResize {
    display: none;
  }
}

.d234fdsa1 {
  position: relative;
  left: 3%;
  top: 3%;
  color: white;
  animation: 30s d9df922f0d1 infinite;
}

.d234fdsa2 {
  position: absolute;
  color: white;
  animation: 60s d9df922f0d1 infinite;
  opacity: 0.5;
}

/* center */
.d234fdsa3 {
  position: fixed;
  top: 5%;
  left: 50%;
  color: white;
  animation: 60s d9df922f0d12 infinite;
  opacity: 0.6;
  transform: translate(-50%, -50%);
}

@keyframes d9df922f0d1 {
  0% {
    left: 3px;
    opacity: 0.5;
  }

  25% {
    opacity: 0;
  }

  50% {
    right: 3px;
    opacity: 0.5;
  }

  75% {
    opacity: 0;
  }
}

@keyframes d9df922f0d {
  0% {
    left: 3%;
    top: 3%;
  }

  25% {
    left: 87%;
    top: 3%;
  }

  50% {
    left: 87%;
    top: 87%;
  }

  75% {
    left: 3%;
    top: 87%;
  }

  100% {
    left: 3%;
    top: 3%;
  }
}

</style>
